<script>
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';

  import Button from '@components/Button.svelte';
  import Text from '@components/Text.svelte';
  import Notification from '@utils/notification';

  import jQuery from 'jquery';
  const dispatch = createEventDispatcher();
  const defaultQuestions = [
    {
      title: '',
      additional_note: '',
    },
  ];

  export let recRequest;
  export let close;
  export let apiRequest;

  let saving = false;
  let questions = recRequest.questions || defaultQuestions;

  let save = function () {
    let filteredQuestions = questions.filter((q) => q.title != '');

    if (filteredQuestions.length == 0) {
      Notification.send({
        text: 'Please enter atleast one recommendation',
        type: 'error',
      });
      return;
    }

    saving = true;
    apiRequest(
      {
        rec_request: {
          rec_request_questions: filteredQuestions,
        },
      },
      async () => {
        saving = false;
        dispatch('saved');
      }
    );
  };

  let updateAdditionalNoteText = function (i, text) {
    questions[i].additional_note = text;
  };

  let updateQuestionTabPressed = function (i, regular) {
    setTimeout(function () {
      let elem = null;

      if (regular) {
        elem = jQuery(`.recommendations-question-${i + 1} > span`);
      } else {
        elem = jQuery(`.recommendations-question-${i - 1} > span`);
      }

      if (elem) {
        elem.focus();
      }
    }, 150);
  };

  let updateQuestionText = function (i, title) {
    questions[i].title = title;

    if (title == '' && questions.length > 1) {
      questions.splice(i, 1);
    }

    addEmptyQuestionSlotIfNeeded();
  };

  let addEmptyQuestionSlotIfNeeded = function () {
    var lastElem = questions[questions.length - 1];

    if (lastElem === undefined || lastElem.title != '') {
      questions.push({
        title: '',
        additional_note: '',
      });
    }

    questions = questions;
  };

  addEmptyQuestionSlotIfNeeded();
</script>

<style style="text/scss" lang="scss">
  .step-title {
    text-align: center;
    font-size: 14px;
    line-height: 26px;
    font-weight: 500;
  }

  .ui-cancel {
    font-weight: 500;
    color: black;

    &:hover {
      opacity: 0.75;
    }
  }
</style>

<div class="step-title">What recommendations are you looking for?</div>

<div style="margin-top: 60px">
  {#each questions as q, i (q)}
    <div in:fade style="display: flex; align-items: flex-start; margin-bottom: 35px;">
      <div
        style="font-size: 18px; line-height: 26px; opacity: 0.5; padding-top:
        4px;">
        {i + 1}.
      </div>
      <div
        style="margin-left: 25px; font-size: 25px; line-height: 30px;
        font-weight: 500; width: 100%;"
        class="recommendations-question-{i}">
        <Text
          placeholder="Tap to add (e.g. Hotels)"
          text={q.title}
          editable={true}
          on:tab-pressed={() => {
            updateQuestionTabPressed(i, true);
          }}
          on:tab-pressed-shift={() => {
            updateQuestionTabPressed(i, false);
          }}
          on:blur={(e) => {
            updateQuestionText(i, e.detail.text);
          }} />
        {#if q.title}
          <div style="font-size: 13px; line-height: 18px; font-weight: normal; margin-top: 5px;">
            <Text
              editable={true}
              text={q.additional_note}
              placeholder="Tap to add additional info (optional)"
              on:blur={(e) => {
                updateAdditionalNoteText(i, e.detail.text);
              }} />
          </div>
        {/if}
      </div>
    </div>
  {/each}
</div>

<div style="margin-top: 60px; margin-left: auto; margin-right: auto; width: 275px">
  {#if saving}
    <Button text="<i class='fa fa-spin fa-spinner'></i>&nbsp;&nbsp;Saving" />
  {:else}
    <Button text="Next" on:click={save} />
  {/if}
  <div style="margin-top: 15px; display: block; text-align: center">
    <a href="#" class="ui-cancel" on:click={close}>Cancel</a>
  </div>
</div>
